import { render, staticRenderFns } from "./Individualaccountopening.vue?vue&type=template&id=10b06d06&scoped=true"
import script from "./Individualaccountopening.vue?vue&type=script&lang=js"
export * from "./Individualaccountopening.vue?vue&type=script&lang=js"
import style0 from "./Individualaccountopening.vue?vue&type=style&index=0&id=10b06d06&prod&lang=css"
import style1 from "./Individualaccountopening.vue?vue&type=style&index=1&id=10b06d06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b06d06",
  null
  
)

export default component.exports